// Каркас карточки «как в Bitrix»: шапка (название, сумма, действия), полоса стадий,
// вкладки, ниже двухколонник — слева содержимое активной вкладки, справа лента,
// которая ОСТАЁТСЯ на месте при смене вкладки (в Bitrix так же). На телефоне колонки
// встают друг под друга (card.css).
//
// Каркас не знает, что за сущность внутри: карточки компании/контакта/судна второй
// волны собираются из него теми же пропсами.
import type { ReactNode } from 'react'

import './card.css'

export interface CardTab { key: string; label: string }

interface Props {
  /** Содержимое шапки (обычно .cshell-head с названием и суммой). */
  head: ReactNode
  /** Полоса стадий (StageBar) — не у каждой сущности она есть. */
  stageBar?: ReactNode
  tabs: CardTab[]
  active: string
  onTab: (key: string) => void
  /** Содержимое активной вкладки — левая колонка. */
  left: ReactNode
  /** Правая колонка (лента). Без неё левая занимает всю ширину. */
  right?: ReactNode
}

export function CardShell({ head, stageBar, tabs, active, onTab, left, right }: Props) {
  return (
    <div className="cshell">
      <div className="card cshell-top">
        {head}
        {stageBar}
        <div className="cshell-tabs">
          {tabs.map((t) => (
            <button
              key={t.key}
              type="button"
              className="cshell-tab"
              aria-pressed={active === t.key}
              onClick={() => onTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>
      {right ? (
        <div className="cshell-grid">
          <div>{left}</div>
          <div className="card">{right}</div>
        </div>
      ) : (
        left
      )}
    </div>
  )
}
